import { render, staticRenderFns } from "./Prevision.vue?vue&type=template&id=6f89ee6f&"
import script from "./Prevision.vue?vue&type=script&lang=js&"
export * from "./Prevision.vue?vue&type=script&lang=js&"
import style0 from "./Prevision.vue?vue&type=style&index=0&id=6f89ee6f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports